import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { deepPurple } from "@mui/material/colors";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";

const Question = ({
  question,
  indexQuestion,
  selectedAnswer,
  callbackOptionSelected,
  pageIndex,
  numPerPage
}) => {
  return (
    <Grid item xs={12}>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: deepPurple[500] }}>
              {numPerPage ? pageIndex == 0 ? indexQuestion + 1 : (indexQuestion + 1) + (numPerPage * pageIndex) : indexQuestion + 1} 
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body1"
                  sx={{ color: "text.primary", display: "inline" }}
                >
                  {parse(question.pregunta)}
                </Typography>
              </React.Fragment>
            }
            secondary={
              <RadioGroup
                name="quiz"
                value={selectedAnswer ? selectedAnswer : false}
                onChange={(event) => {
                  callbackOptionSelected(event.target.value, indexQuestion);
                }}
                row
                style={{ margin: "auto", flexDirection: "column" }}
              >
                {question.options.map((option, index) => (
                  <FormControlLabel
                    key={`${option.id}-${option.respuesta}-${question.id}`}
                    value={`${option.id}-${option.respuesta}-${question.id}`}
                    control={<Radio />}
                    label={parse(option.texto_opcion)}
                  />
                ))}
              </RadioGroup>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
      </List>
    </Grid>
  );
};

export default Question;
